import React from 'react';
export function LeadSection() {
  return <section id="problem" className="py-16 md:py-20 px-4 sm:px-6" data-id="element-153">
      <div className="max-w-2xl mx-auto" data-id="element-154">
        <p className="text-2xl md:text-3xl lg:text-4xl font-playfair font-bold text-text-primary mb-8 leading-tight" data-id="element-155">
          There's something nobody tells you about this.
        </p>
        <img src="https://cdn.magicpatterns.com/uploads/dkmHuq4cWQyeDTppiRPAGW/heylloyd-image-1773364230389.png" alt="Man sitting on edge of bed, stressed" className="w-full max-w-2xl mx-auto h-auto rounded-xl border border-dark-border shadow-lg mb-10" data-id="element-156" />
        <p className="text-base md:text-lg text-text-secondary mb-6 leading-relaxed" data-id="element-157">
          It's not what you eat. It's not your testosterone. It's not that
          you're 50.
        </p>
        <p className="text-base md:text-lg text-text-secondary mb-8 leading-relaxed" data-id="element-158">
          It's that the exact moment intimacy begins, your brain turns into a
          surveillance camera.
        </p>
        <p className="text-base md:text-lg text-text-secondary mb-5 leading-relaxed" data-id="element-159">
          It starts scanning. It starts predicting. It starts asking:
        </p>

        <div className="bg-[#151820] border-l-4 border-gold p-5 md:p-6 rounded-xl mb-8 space-y-3" data-id="element-160">
          <p className="text-lg font-playfair italic text-gold" data-id="element-161">
            "Is it happening?"
          </p>
          <p className="text-lg font-playfair italic text-gold" data-id="element-162">
            "Is she noticing?"
          </p>
          <p className="text-lg font-playfair italic text-gold" data-id="element-163">
            "What if it fails me again?"
          </p>
          <p className="text-lg font-playfair italic text-gold" data-id="element-164">
            "What does this say about me?"
          </p>
        </div>

        <p className="text-base md:text-lg text-text-secondary mb-6 leading-relaxed" data-id="element-165">
          And that silent scanner doesn't feel like fear. It feels like{' '}
          <span className="text-text-primary" data-id="element-166">being realistic.</span>
        </p>
        <p className="text-base md:text-lg text-text-secondary mb-6 leading-relaxed" data-id="element-167">
          But your body reads it as a threat.
        </p>
        <p className="text-lg md:text-xl text-text-primary font-medium leading-relaxed" data-id="element-168">
          And when the nervous system triggers the danger alarm... arousal
          disappears. Not because you're broken.{' '}
          <span className="text-gold" data-id="element-169">Because you're monitoring yourself.</span>
        </p>
      </div>
    </section>;
}